// extracted by mini-css-extract-plugin
module.exports = {"actual":"a10a3f92e9--actual--ZDdsh","label":"a10a3f92e9--label--PKvas","description":"a10a3f92e9--description--ntH33","link":"a10a3f92e9--link--VNUIW"};